const manutencao_retorno_vaga_para_escola = {
  path: "/manutencao-do-retorno-da-vaga-para-escola",
  redirect: "/manutencao-do-retorno-da-vaga-para-escola",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Parâmetros por Escola",
  },
  children: [
    {
      path: "/manutencao-do-retorno-da-vaga-para-escola/novo",
      name: "manutencao_do_retorno_da_vaga_para_escola_novo",
      meta: {
        allowedPermissions: ["retorno_vaga_escola_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDoRetornoDaVagaParaEscola/ManutencaoDoRetornoDaVagaParaEscolaCad.vue"
        ),
    },
    {
      path: "/manutencao-do-retorno-da-vaga-para-escola/edit/:id",
      name: "manutencao_do_retorno_da_vaga_para_escola_atualizar",
      meta: {
        allowedPermissions: ["retorno_vaga_escola_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDoRetornoDaVagaParaEscola/ManutencaoDoRetornoDaVagaParaEscolaEdit.vue"
        ),
    },
    {
      path: "/manutencao-do-retorno-da-vaga-para-escola",
      name: "manutencao_do_retorno_da_vaga_para_escola",
      meta: {
        allowedPermissions: ["retorno_vaga_escola_index"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDoRetornoDaVagaParaEscola/ManutencaoDoRetornoDaVagaParaEscolaHome.vue"
        ),
    },
  ],
};

export { manutencao_retorno_vaga_para_escola };
